<template>
  <div>
    <div class="modal" :class="{ 'is-active': !userJoined }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add your Character</p>
          <button class="delete" aria-label="back" @click.prevent="goBack()"></button>
        </header>
        <form @submit.prevent="addPlayer()">
          <section class="modal-card-body">
              <div class="field">
                <p class="control has-icons-left">
                  <input 
                  v-model="name" 
                  placeholder="Character Name" 
                  class="input is-rounded is-medium" 
                  required>
                  <span class="icon is-left">
                    <i class="fas fa-user-circle"></i>
                  </span>
                </p>
              </div>
              <div class="field has-addons">
                <p class="control">
                  <label 
                  class="button is-rounded is-dark" 
                  :class="{'is-outlined' : rollStyle !== 'app'}"
                  for="style-app">Roll in App</label>
                  <input 
                  id="style-app"
                  type="radio"
                  name="rollStyle"
                  :checked="rollStyle === 'app'"
                  @change="updateRollStyle('app')"
                  style="display:none">
                </p>
                <p class="control">
                  <label 
                  class="button is-rounded is-dark" 
                  :class="{'is-outlined' : rollStyle !== 'manual'}"
                  for="style-manual">Roll on the table</label>
                  <input 
                  id="style-manual"
                  type="radio"
                  name="rollStyle"
                  :checked="rollStyle === 'mannual'"
                  @change="updateRollStyle('manual')"
                  style="display:none">
                </p>
              </div>
              <div v-if="rollStyle === 'app'" class="field">
                <p class="control has-icons-left">
                  <input 
                  v-model="modifier" 
                  type="number"
                  placeholder="Initiative Modifier (optional)" 
                  class="input is-rounded is-medium"
                  required>
                  <span class="icon is-left">
                    <i class="fas fa-plus-circle"></i>
                  </span>
                </p>
              </div>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-rounded is-info is-fullwidth is-medium">Join Campaign</button>
          </footer>
        </form>
      </div>
    </div>
    <section class="party-list">
      <div class="columns">
        <div class="column is-offset-1 is-4-widescreen">
          <PlayerEdit
          :campaignId="id"/>
        </div>
        <div class="column is-5 is-6-widescreen">
          <article 
          v-for="player in party" 
          class="party"
          :key="player.id">
          <PlayerCard 
            :campaignId="id" 
            :member="player"/>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { db } from '../main'
import PlayerCard from '../components/PlayerCard.vue'
import PlayerEdit from '../components/PlayerEdit.vue'

export default {
  name: 'CampaignPlayer',
  props: {
    id: String,
  },
  data () {
    return {
      party: [],
      name: null,
      modifier: null,
    }
  },
  firestore () {
    this.$bind('party', db.collection('campaigns').doc(this.id).collection('party').orderBy('initiative', 'desc'))
  },
  computed: {
    ...mapGetters(['user', 'rollStyle']),
    userId () {
      return this.user.uid
    },
    userJoined: function() {
      return (this.party.filter((item) => item.user === this.userId).length) ? true : false
    },
  },
  methods: {
    goBack () {
      this.$router.push('/campaigns')
    },
    addPlayer () {
      const user = this.userId
      const name = this.titleCase(this.name)
      const modifier = parseInt(this.modifier)
      const initiative = null
      const type = 'player'
      db.collection('campaigns')
        .doc(this.id)
        .collection('party')
        .add({ 
          user, 
          name, 
          initiative, 
          modifier, 
          type 
        })
        .then(() => {
          console.log('player added to campaign!')
        })
      this.name = null
      this.modifier = null
    },
    updateRollStyle (value) {
      this.$store.commit('updateRollStyle', value);
    }
  },
  components: {
    PlayerCard,
    PlayerEdit,
  }
}
</script>
<style scoped>
.party-list {
  width: 100%;
}
/* .party {
  margin-bottom: 1.5em;
  background-color: white;
} */
.party:not(:last-child) .player-card {
  margin-bottom: 1.5em;
}
@media screen and (min-width: 769px) {
  .column:first-child {
    order: 2;
  }
}
@media screen and (max-width: 768px) {
  .column {
    margin-bottom: 1.5em;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/CampaignPlayer.vue